import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { useMemo, useCallback, createElement } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { createLocation } from 'history';
import { callIfPossible } from 'UIComponents/core/Functions';

const AbstractRouterLink = props => {
  const {
    component,
    to,
    replace,
    onClick
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["component", "to", "replace", "onClick"]);

  const history = useHistory();
  const handleClick = useCallback(e => {
    callIfPossible(onClick, e);

    if (e.defaultPrevented) {
      return;
    }

    if (e && !e.metaKey) {
      e.preventDefault();

      if (replace) {
        history.replace(to);
      } else {
        history.push(to);
      }
    }
  }, [history, onClick, replace, to]);
  const href = useMemo(() => {
    const location = typeof to === 'string' ? createLocation(to, null, undefined, history.location) : to;
    return history.createHref(location);
  }, [history, to]);
  return /*#__PURE__*/createElement(component, Object.assign({}, rest, {
    href,
    onClick: handleClick
  }));
};

AbstractRouterLink.propTypes = {
  component: PropTypes.elementType.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  replace: PropTypes.bool
};
AbstractRouterLink.defaultProps = {
  replace: false
};
export default AbstractRouterLink;